import base from './base';
import setting from './setting';
export default {
  base,
  setting,
};
